import React from 'react';
import { styled } from 'linaria/react';
import DropButton from '../../ui/DropButton';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import { TabContent } from './DesktopTabs';
import { theme } from '../../Theming/Theming';

const DropMenu = styled('div')`
  margin: 0 0 3rem 0;
`;
const DropItem = styled('div')`
  border-top: 1px solid ${theme.colors.border};
  padding: 1rem 0.2rem;
  &:last-child {
    border-bottom: 1px solid ${theme.colors.border};
  }
  .drop-body {
    display: none;
  }
  &.active {
    .drop-header {
      color: ${theme.colors.primary};
    }
    .drop-body {
      display: block;
    }
  }
`;
const DropHeader = styled('h3')`
  padding: 0.5rem 0.2rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: ${theme.productPage.tabs.header.fontFamily} !important;
  font-weight: ${theme.productPage.tabs.header.fontWeight} !important;
  &:hover {
  }
  .drop-text {
  }
  .drop-button-wrapper {
  }
`;
const DropBody = styled('div')`
  padding-top: 1rem;
`;

export const MobileDrops = ({ tabsData }) => {
  return (
    <DropMenu>
      <Accordion initialOpenIndexes={[0]}>
        {({ openIndexes, handleClick, AccordionContent }) => {
          return (
            <>
              {tabsData.map((item, index) => (
                <DropItem key={index}>
                  <DropHeader
                    onClick={() => handleClick(index)}
                    id={'drop-header-' + item.id}
                  >
                    <span className="drop-text">{item.header}</span>
                    <DropButton
                      data-isopen={openIndexes.includes(index)}
                      size={22}
                    />
                  </DropHeader>
                  <AccordionContent isOpen={openIndexes.includes(index)}>
                    <DropBody>
                      <TabContent>{item.body}</TabContent>
                    </DropBody>
                  </AccordionContent>
                </DropItem>
              ))}
            </>
          );
        }}
      </Accordion>
    </DropMenu>
  );
};
